<template>
  <div>
    <div v-if="isMakerlab">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              label="*Nome"
              v-model="result.first_name"
              :rules="[v => !!v || 'Nome é obrigatório']"
              required
            ></v-text-field>
            <v-text-field
              label="*Sobrenome"
              v-model="result.last_name"
              :rules="[v => !!v || 'Sobrenome é obrigatório']"
              required
            ></v-text-field>
            <v-text-field
              label="*E-mail"
              v-model="result.email"
              :rules="emailRules"
              @input="sugestao()"
              required
            ></v-text-field>
            <v-text-field
              label="*Nome de usuário"
              v-model="result.username"
              required
              :counter="30"
              :error-messages="errors"
              maxlength="30"
              :rules="usernameRules"
              @blur="doesUsernameExists"
            ></v-text-field>
            <v-autocomplete
              label="*Unidade"
              :items="options"
              item-text="name"
              item-value="name"
              multiple
              v-model="result.unidade"
              max-height="400"
              hint="Escolha a unidade"
              persistent-hint
              required
              :rules="[ value => value.length >= 1 || 'Unidade é obrigatória.']"
            ></v-autocomplete>
          <v-flex xs12>
            <v-select
              label="*Tipo de Usuário"
              :items="groupsOptions"
              multiple
              required
              item-text="label"
              item-value="value"
              max-height="400"
              v-model="result.groups"
              :rules="[ value => value.length >= 1 || 'Tipo é obrigatório.']"
            ></v-select>
            <div v-if="showField">
              <v-autocomplete
                label="Mediador"
                :items="listamediador"
                item-text="username"
                v-model="result.mediador"
                max-height="400"
                hint="Escolha o responsável pelo aluno"
                persistent-hint
              ></v-autocomplete>
              <v-autocomplete
                label="Turma"
                :items="turma"
                item-text="name"
                item-value="slug"
                multiple
                v-model="result.turma_set"
                max-height="400"
                hint="Escolha a turma"
                persistent-hint
              ></v-autocomplete>
            </div>
          </v-flex>
              <v-btn color="primary"  @click.native="proximo" >Continuar</v-btn>
                    <!-- Utilização do Script -->
              <!-- <v-btn @click="importar">Script</v-btn> -->
          </v-flex>
        </v-layout>
      </v-form>
    </div>
    <!-- Usuário Não MakerLab -->
    <div v-if="!isMakerlab" >
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              label="*Tipo de Usuário"
              :items="groupsOptions"
              multiple
              required
              item-text="label"
              item-value="value"
              max-height="400"
              v-model="result.groups"
              :rules="[ value => value.length >= 1 || 'Tipo é obrigatório.']"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="*Nome de usuário"
              v-model="result.username"
              required
              :counter="30"
              maxlength="30"
              :error-messages="errors"
              :rules="usernameRules"
              @blur="doesUsernameExists"
            ></v-text-field>
            <v-text-field
              label="Nome"
              v-model="result.first_name"
              :rules="[v => !!v || 'Nome é obrigatório']"
              required
            ></v-text-field>
            <v-text-field
              label="Sobrenome"
              v-model="result.last_name"
              :rules="[v => !!v || 'Sobrenome é obrigatório']"
              required
            ></v-text-field>
            <v-text-field
              label="E-mail"
              v-model="result.email"
              :rules="emailRules"
              required
            ></v-text-field>
            <v-menu
              ref="menu"
              lazy
              :close-on-content-click="false"
              v-model="menu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                label="Data de nascimento"
                v-model="computedDateFormatted"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                ref="picker"
                v-model="result.birthdate"
                locale="pt-br"
                min="1910-01-01"
                :max="new Date().toISOString().substr(0, 10)"
              ></v-date-picker>
            </v-menu>
            <v-select
              label="Gênero"
              :items="genero"
              item-text="tipo"
              item-value="acron"
              v-model="result.gender"
              max-height="400"
            ></v-select>
            <v-text-field
              label="RG"
              v-model="result.rg"
              mask="##.###.###-N"
            ></v-text-field>
            <v-text-field
              label="Orgão emissor"
              v-model="result.orgaoemissor"
            ></v-text-field>
            <v-text-field
              label="Estado de emissão"
              v-model="result.estadoemissor"
              mask="AA"
            ></v-text-field>
            <v-text-field
              label="CPF"
              mask="###.###.###-##"
              v-model="result.cpf"
            ></v-text-field>
            <v-autocomplete
              label="Unidade"
              :items="options"
              item-text="name"
              item-value="name"
              multiple
              v-model="result.unidade"
              max-height="400"
              hint="Escolha a unidade"
              persistent-hint
              required
              :rules="[ value => value.length >= 1 || 'Unidade é obrigatória.']"
            ></v-autocomplete>
              <v-btn color="primary"  @click.native="proximo" >Continuar</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </div>
  </div>

</template>

<script>
import api from '@/api'
import json from './../../../../../script.json'
export default {
  data () {
    return {
      groupsOptions: [{label: 'Aluna(o)',
        value: 'Aluno'}, {label: 'Mediador(a)',
          value: 'Mediador'}, {
            label: 'Coordenador(a)',
            value: 'Coordenador'}, {
              label: 'Secretaria',
              value: 'Secretaria'}, {
                label: 'Administrador(a)',
                value: 'Admin'}],
      result: {
        turma_set: [],
        can_delete_projecto: true,
        can_delete_turma: true,
        can_delete_user: true
      },
      options: {},
      turma: [],
      listamediador: [],
      usernameExists: false,
      data: null,
      mylist: json,
      showField: false,
      menu: false,
      errors: '',
      showCheckBox: false,
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => this.validemail(v)
      ],
      cpfRules: [
        v => this.testaCPF(v)
      ],
      usernameRules: [
        v => !!v || 'Nome de usuário é obrigatório',
        v => this.validuser(v)
      ],
      valid: true,
      menu2: false,
      genero: [
            {acron: 'F', tipo: 'Feminino'},
            {acron: 'M', tipo: 'Masculino'},
            {acron: 'O', tipo: 'Outro'}
      ]
    }
  },
  mounted () {
    api.request('GET', 'unidade/').then((response) => {
      this.options = response.data
      console.log(this.options)
    })
    this.$watch('result.groups', () => {
      this.checkGroup()
    })

    api.request('GET', 'search-user?groups__name=Mediador').then(resp => {
      this.listamediador = resp.data;
    });

    api.request('GET', 'turmas/').then(response => {
      this.turma = response.data
    });

    this.$watch('usernameExists', () => {
      if (this.usernameExists) {
        this.errors = 'Nome de usuário já existe'
      } else {
        this.errors = ''
      }
    })
  },
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.result.birthdate)
    },
    isMakerlab () {
      return this.$store.state.company.makerlab;
    }
  },
  beforeDestroy () {
  },
  methods: {
    doesUsernameExists () {
      api.request('GET', 'search-user?username=' + this.result.username)
        .then(resp => {
          if (resp.data.length >= 1) {
            this.usernameExists = true
          } else {
            this.usernameExists = false
          }
          if (this.result.username === '') {
            this.usernameExists = false
          }

          console.log(this.usernameExists)
        })
    },
    validemail (value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'E-mail inválido'
    },
    validuser (value) {
      const pattern = /^([A-Za-z@.+\-_]+)$/
      return pattern.test(value) || 'Este campo pode conter apenas letras e os seguintes caracteres @ . + - _ .'
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    sugestao () {
      this.result.username = this.result.email
    },
    proximo () {
      if (!this.usernameExists) {
        if (this.$refs.form.validate()) {
          this.$emit('dados1', this.result)
          this.$emit('next')
        }
      }
    },
    checkGroup () {
      this.showField = false
      for (let index = 0; index < this.result.groups.length; index++) {
        if (this.result.groups[index] === 'Aluno') {
          this.showField = true
        }
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    testaCPF (strCPF) {
      if (strCPF === '' || strCPF === undefined) return true
      var Soma
      var Resto
      Soma = 0
      var i
      if (strCPF === '00000000000') return false || 'CPF inválido';

      for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto === 10) || (Resto === 11)) Resto = 0;
      if (Resto !== parseInt(strCPF.substring(9, 10))) return false || 'CPF inválido';

      Soma = 0;
      for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto === 10) || (Resto === 11)) Resto = 0;
      if (Resto !== parseInt(strCPF.substring(10, 11))) return false || 'CPF inválido';
      return true;
    },
    importar () {
        //  site: http://processr.com/#/use/109
      console.log('dados lista', this.mylist)
      console.log('dados lista', this.mylist.length)
      for (let index = 0; index < this.mylist.length; index++) {
        api.request('POST', 'create-user/', this.mylist[index]).then(resp => {
          console.log(resp)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Usuarios/CadastroSteps/Step1.vue